export default ({
    sections, currentSectionId, repeater, dependData, repeaterId,
}) => {
    let progress = 100 / sections.length * (currentSectionId + 1);

    if (repeater && dependData) {
        progress =
            100 /
            (sections.length + dependData.length) *
            (currentSectionId + +repeaterId + 1);
    }

    return progress;
};



// WEBPACK FOOTER //
// ./src/utils/getProgress.js